/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["gauerd.","goizald.","goizeko","eguerd.","arrats.","iluntz.","gaueko"],["gauerdia","goizald.","goizeko","eguerd.","arrats.","iluntz.","gaueko"],["gauerdia","goizaldeko","goizeko","eguerdiko","arratsaldeko","iluntzeko","gaueko"]],[["gauerdia","goizald.","goiza","eguerd.","arrats.","iluntz.","gaua"],["gauerdia","goiz.","goiza","eguerd.","arrats.","iluntz.","gaua"],["gauerdia","goizaldea","goiza","eguerdia","arratsaldea","iluntzea","gaua"]],["00:00",["00:00","06:00"],["06:00","12:00"],["12:00","14:00"],["14:00","19:00"],["19:00","21:00"],["21:00","24:00"]]];
